// extracted by mini-css-extract-plugin
module.exports = {"Logo":"Logo_Logo__d04QA","full":"Logo_full__2hEIc","iconOnly":"Logo_iconOnly__2BMq2"};